import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMoneyBills = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.4375 8.25C5.49931 8.25 5.55973 8.26833 5.61112 8.30267C5.66251 8.337 5.70256 8.38581 5.72621 8.44291C5.74986 8.50001 5.75605 8.56285 5.744 8.62347C5.73194 8.68408 5.70217 8.73977 5.65847 8.78347C5.61477 8.82718 5.55908 8.85694 5.49847 8.869C5.43785 8.88105 5.37501 8.87486 5.31791 8.85121C5.26081 8.82756 5.212 8.78751 5.17767 8.73612C5.14333 8.68473 5.125 8.62431 5.125 8.5625C5.125 8.47962 5.15792 8.40013 5.21653 8.34153C5.27513 8.28292 5.35462 8.25 5.4375 8.25Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0625 12.625C16.1243 12.625 16.1847 12.6433 16.2361 12.6777C16.2875 12.712 16.3276 12.7608 16.3512 12.8179C16.3749 12.875 16.3811 12.9378 16.369 12.9985C16.3569 13.0591 16.3272 13.1148 16.2835 13.1585C16.2398 13.2022 16.1841 13.2319 16.1235 13.244C16.0628 13.2561 16 13.2499 15.9429 13.2262C15.8858 13.2026 15.837 13.1625 15.8027 13.1111C15.7683 13.0597 15.75 12.9993 15.75 12.9375C15.75 12.8546 15.7829 12.7751 15.8415 12.7165C15.9001 12.6579 15.9796 12.625 16.0625 12.625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 6.75C2.625 6.19772 3.07272 5.75 3.625 5.75H17.875C18.4273 5.75 18.875 6.19772 18.875 6.75V14.75C18.875 15.3023 18.4273 15.75 17.875 15.75H3.625C3.07272 15.75 2.625 15.3023 2.625 14.75V6.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 10.75C8.25 11.413 8.51339 12.0489 8.98223 12.5178C9.45107 12.9866 10.087 13.25 10.75 13.25C11.413 13.25 12.0489 12.9866 12.5178 12.5178C12.9866 12.0489 13.25 11.413 13.25 10.75C13.25 10.087 12.9866 9.45107 12.5178 8.98223C12.0489 8.51339 11.413 8.25 10.75 8.25C10.087 8.25 9.45107 8.51339 8.98223 8.98223C8.51339 9.45107 8.25 10.087 8.25 10.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 9.5V17C21.375 17.3315 21.2433 17.6495 21.0089 17.8839C20.7745 18.1183 20.4565 18.25 20.125 18.25H6.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMoneyBills.displayName = 'SvgMoneyBills';
export default SvgMoneyBills;
